// Export the Component Definition for use in Contentful Studio
export {CourseCatalogContentfulComponentDefinition} from './CourseCatalogContentfulDefinition';
export type {CourseCatalogProps, CourseEntry} from './CourseCatalog';
export {default} from './CourseCatalog';
